import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  expandedRow: {
    background: theme.hv.palette.atmosphere.atmo1,
  },
  expandedRowTop: {},
  expandedRowBottom: {},
  expandedCell: {
    border: 0,
    "$expandedRowTop &": {
      paddingTop: theme.hv.spacing.sm,
    },
    "$expandedRowBottom &": {
      paddingBottom: theme.hv.spacing.sm,
    },
  },
}));

export default styles;
